<template>
  <div class="">
    <div class="card">
      <div class="header">
        <h2>Token 교환 Endpoint(필수)</h2>
        <p></p>
      </div>
      <div>
        <!-- Select -->
        <div class="row clearfix">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <dev-auth-input-two-modes v-bind:requestIndex="0" />
          </div>
        </div>
        <!-- #END# Select -->
      </div>

      <div style="text-align: right; margin-bottom: 10px; margin-right: 10px">
        <!-- <router-link to="/developer/authentication/fields"><button class="btn btn-default">Add Fields</button></router-link> -->
        <button type="button" class="btn btn-primary" @click="saveRequest">
          저장 후 계속
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DevAuthInputTwoModes from "@/views/dev/auth/DevAuthInputTwoModes";

import eventbus from "@/store/modules/devEventBus";

export default {
  props: ["requestIndex"],
  components: {
    DevAuthInputTwoModes: DevAuthInputTwoModes,
  },

  data() {
    return {
      twoStatus: false,
      formStatus0: true,
      codeStatus0: false,
      formStatus1: true,
      codeStatus1: false,
      formStatus2: true,
      codeStatus2: false,
      formStatus3: true,
      codeStatus3: false,

      formStatus5: true,

      labelStatus: true,
      editStatus: false,

      method: null,
      url: null,
      emptyParam: 0,
      blankParam: 0,
    };
  },
  methods: {
    switchView: function (num) {
      switch (num) {
        case 0:
          this.formStatus0 = !this.formStatus0;
          this.codeStatus0 = !this.codeStatus0;
          break;
        case 1:
          this.formStatus1 = !this.formStatus1;
          this.codeStatus1 = !this.codeStatus1;
          break;
        case 2:
          this.formStatus2 = !this.formStatus2;
          this.codeStatus2 = !this.codeStatus2;
          break;
        case 3:
          this.formStatus3 = !this.formStatus3;
          this.codeStatus3 = !this.codeStatus3;
          break;
        case 5:
          this.formStatus5 = !this.formStatus5;
          break;
      }

      // this.formStatus = !this.formStatus
      // this.codeStatus = !this.codeStatus+num
    },
    connectionLabelForm: function () {
      this.labelStatus = !this.labelStatus;
      this.editStatus = !this.editStatus;
    },
    deleteInputs: function () {
      console.log("...");
    },
    saveRequest() {
      console.log(this.requestIndex);
      console.log(this.$store.state.devStore.paramMap[0]);

      var paramList = new Map();
      if (this.$store.state.devStore.paramMap[0] != undefined) {
        for (
          var i = 0;
          i < this.$store.state.devStore.paramMap[0].length;
          i++
        ) {
          console.log("param map :", this.$store.state.devStore.paramMap[0][i]);
          paramList.set(
            this.$store.state.devStore.paramMap[0][i].keys,
            this.$store.state.devStore.paramMap[0][i].values
          );
        }
      }
      var headerList = new Map();
      if (this.$store.state.devStore.headerMap[0] != undefined) {
        for (
          var j = 0;
          j < this.$store.state.devStore.headerMap[0].length;
          j++
        ) {
          console.log(this.$store.state.devStore.headerMap[0][j]);
          headerList.set(
            this.$store.state.devStore.headerMap[0][j].keys,
            this.$store.state.devStore.headerMap[0][j].values
          );
        }
      }

      var bodyList = new Map();
      if (this.$store.state.devStore.bodyMap[0] != undefined) {
        for (var k = 0; k < this.$store.state.devStore.bodyMap[0].length; k++) {
          console.log(this.$store.state.devStore.bodyMap[0][k]);
          bodyList.set(
            this.$store.state.devStore.bodyMap[0][k].keys,
            this.$store.state.devStore.bodyMap[0][k].values
          );
        }
      }

      // var optionList = new Map()
      // if(this.$store.state.devStore.optionMap != undefined){
      //     var check1 = 0
      //     var check2 = 0

      //     console.log("submit:",this.$store.state.devStore.optionMap[0])

      //     var val1 = this.$store.state.devStore.optionMap[0].param
      //     var val2 = this.$store.state.devStore.optionMap[0].field
      //     if(val1 == true){check1 = 1}
      //     if(val2 == true){check2 = 1}

      //     optionList.set("param", check1)
      //     optionList.set("field", check2)

      // }

      // console.log(this.$store.state.devStore.optionMap[0])
      // console.log(optionList)

      var data = {
        url: this.url,
        method: this.method,
        header: Object.fromEntries(headerList),
        urlParam: Object.fromEntries(paramList),
        requestBody: Object.fromEntries(bodyList),
        // options: Object.fromEntries(this.$store.state.devStore.optionMap[0]),
        autoEmptyParam: this.emptyParam,
        autoBlankParamDelete: this.blankParam,
      };

      this.$store.state.devStore.configureData[0].form = data;

      console.log(JSON.stringify(this.$store.state.devStore.configureData));

      //       //여기서 저장
      var param = {
        appCode: this.$store.state.devStore.appCode,
        apiCode: this.$store.state.devStore.apiCode,

        checkType: this.$store.state.devStore.apiData.apiName,
        where: "request",

        apiSchema: JSON.stringify(this.$store.state.devStore.configureData),
      };

      this.api.configSchema(param)
        .then((res) => {
          console.log("저장 : ", res);

          this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
              .then((res)=>{
                this.$store.dispatch("apiDetail", {result : res}).then(() => {
                  // this.$router.push({
                  // name: "DevAuthSettings",
                  // params: {
                  // },
                  // });
                });

              })

        })
        .catch(() => alert("오류가 발생했습니다. auth fields"));
    },
  },

  mounted() {},
  created() {
    eventbus.$on("omitDatas", (res) => {
      console.log(res);

      this.emptyParam = res[0];
      this.blankParam = res[1];
    });

    this.$store.state.devStore.paramMap = [{}, {}, {}, {}];

    this.$store.state.devStore.headerMap = [{}, {}, {}, {}];

    this.$store.state.devStore.bodyMap = [{}, {}, {}, {}];

    // this.$store.state.devStore.optionMap = [{},{},{},{}];

    eventbus.$on("method", (res, index) => {
      console.log("메소드: ", res, index);

      this.method = res.method;
      this.url = res.url;

      // this.method = res
    });

    this.url = JSON.parse(
      this.$store.state.devStore.configureData[0].form
    )[0].url;
    this.method = JSON.parse(
      this.$store.state.devStore.configureData[0].form
    )[0].method;

    this.emptyParam = JSON.parse(
      this.$store.state.devStore.configureData[0].form
    )[0].autoEmptyParam;
    this.blankParam = JSON.parse(
      this.$store.state.devStore.configureData[0].form
    )[0].autoBlankParamDelete;

    this.requestIndex = 0;

    if (
      Object.keys(
        JSON.parse(this.$store.state.devStore.configureData[0].form)[0].urlParam
      ).length > 0
    ) {
      var inin = new Array();

      for (
        var i = 0;
        i <
        Object.keys(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[0]
            .urlParam
        ).length;
        i++
      ) {
        var data = new Object();
        data.keys = Object.keys(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[0]
            .urlParam
        )[i];
        data.values = Object.values(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[0]
            .urlParam
        )[i];
        inin.push(data);
      }

      // this.inputs = inin
      this.$store.state.devStore.paramMap[0] = inin;

      console.log("param parma : ", this.$store.state.devStore.paramMap[0]);
    }

    if (
      Object.keys(
        JSON.parse(this.$store.state.devStore.configureData[0].form)[0].header
      ).length > 0
    ) {
      var inin1 = new Array();

      for (
        var j = 0;
        j <
        Object.keys(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[0].header
        ).length;
        j++
      ) {
        data = new Object();
        data.keys = Object.keys(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[0].header
        )[j];
        data.values = Object.values(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[0].header
        )[j];
        inin1.push(data);
      }

      // this.inputs = inin
      this.$store.state.devStore.headerMap[0] = inin1;

      console.log("param parma : ", this.$store.state.devStore.headerMap[0]);
    }

    if (
      Object.keys(
        JSON.parse(this.$store.state.devStore.configureData[0].form)[0]
          .requestBody
      ).length > 0
    ) {
      var inin2 = new Array();
      for (
        var k = 0;
        k <
        Object.keys(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[0]
            .requestBody
        ).length;
        k++
      ) {
        data = new Object();
        data.keys = Object.keys(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[0]
            .requestBody
        )[k];
        data.values = Object.values(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[0]
            .requestBody
        )[k];
        inin2.push(data);
      }

      // this.inputs = inin
      this.$store.state.devStore.bodyMap[0] = inin2;

      console.log("param parma : ", this.$store.state.devStore.bodyMap[0]);
    }

    //     console.log(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].options)
    //     if(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].options != undefined){
    //         var inin3 = new Array()

    //         var check1 = false
    //         var check2 = false

    //         console.log("마맘" , )
    //         console.log(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].options.param)
    //         if(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].options.param == 1){
    //             check1 = true

    //         }
    //         if(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].options.field == 1){
    //             check2 = true

    //         }
    // //   console.log(Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].options)[0])
    // //   if(Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].options)[0]==1){
    // //   }
    // //   if(Object.values(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].options)[0]==1){
    // //       check2 = true
    // //   }

    //   var tt = {'param':check1, 'field':check2}
    // //   console.log("tt:", tt)
    //   inin3.push(tt)
    //   console.log("tt:", inin3)

    //   this.$store.state.devStore.optionMap[0] = inin3
    //   console.log( this.$store.state.devStore.optionMap)

    // }
    console.log(
      "created session token .... ",
      JSON.parse(this.$store.state.devStore.configureData[0].form)[0].url
    );
    console.log(
      "created session token@2222222 .... ",
      JSON.parse(this.$store.state.devStore.configureData[0].form)[0].urlParam
    );
    console.log(
      "created session token@2222222 .... ",
      this.$store.state.devStore.paramMap
    );
    console.log(
      "created session token@2222222 .... ",
      this.$store.state.devStore.headerMap
    );
    console.log(
      "created session token@2222222 .... ",
      this.$store.state.devStore.bodyMap
    );

    // console.log(this.requestIndex)
  },
  beforeDestroy() {
    eventbus.$off("omitDatas");
  },
};
</script>
